export const ADD_BOM_TYPE = 'ADD_BOM_TYPE';
export const ADD_BOM_GROUP = 'ADD_BOM_GROUP';
export const GET_ALL_BOM = 'GET_ALL_BOM';
export const GET_FACTORY_PRODUCT_TYPES = 'GET_FACTORY_PRODUCT_TYPES';
